(function () {
  'use strict';

  document.querySelectorAll('[data-rob-lp-pack-list]').forEach(function (list) {
    var section = list.closest('.rob-lp-starter-pack');
    if (!section) return;

    var buttons = list.querySelectorAll('[data-rob-lp-pack]');
    var swapTiles = section.querySelectorAll('[data-rob-lp-swap-ingredient]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var packId = button.getAttribute('data-rob-lp-pack');

        buttons.forEach(function (btn) {
          var isSelected = btn === button;
          btn.classList.toggle('rob-lp-starter-pack__pack--selected', isSelected);
          btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        swapTiles.forEach(function (tile) {
          tile.hidden = tile.getAttribute('data-rob-lp-swap-ingredient') !== packId;
        });
      });
    });
  });
})();
